import { mapGetters, mapActions } from 'vuex'
import { router } from '_/router/router'
import { store } from '_/vuex/store'

export default {
  /**
   * Set the computed variables
   *
   * @type  {object}
   */
  computed: {
    ...mapGetters({
      error: 'error/error',
      user: 'user/user',
    }),

    invalidToken: function() {
      return this.error.errorName === 'invalid-token'
    },
  },

  /**
   * Set the beforeRouteEnter hook
   *
   * @return  {void}
   */
  beforeRouteEnter: function(to, from, next) {
    if (!to.params || !to.params.errorName) {
      store.dispatch('error/set404State')
    }

    // If api not responding return 503 error page
    if (to.params.errorName === 'api-not-accessible') {
      store.dispatch('error/setError', {
        errorName: to.params.errorName,
        errorCode: '503',
        errorIcon: 'fal fa-frown',
        errorText: 'API Service Unavailable.',
      })
    }

    // If the token is invalid return 401 error page
    if (to.params.errorName === 'invalid-token') {
      store.dispatch('error/setError', {
        errorName: to.params.errorName,
        errorCode: '401',
        errorIcon: 'fal fa-frown',
        errorText: 'Invalid Token. Not logged in.',
      })
    }

    // If unauthorized return 401 error page
    if (to.params.errorName === 'unauthorized') {
      store.dispatch('error/setError', {
        errorName: to.params.errorName,
        errorCode: '401',
        errorIcon: 'fal fa-frown',
        errorText: 'Unauthorized action.',
      })
    }

    next()
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    // Map actions from ui module namespace
    ...mapActions('ui', ['setBodyClass', 'setTitle']),

    // Map actions from error module namespace
    ...mapActions('error', ['set404State', 'setError']),

    ...mapActions('user', ['removeSessionData']),

    logout() {
      this.removeSessionData().then(() => {
        router.push('/login')
      })
    },
  },

  /**
   * Call a mounted hook
   *
   * @type  {function}
   * @return  void
   */
  mounted: function() {
    this.$nextTick(function() {
      this.setBodyClass('dashboard-page')

      this.setTitle("There's been an error.")
    })
  },
}
